import React, { Component } from "react";
import { WidgetTypes } from "../../../constants/QuestionTypes";
import { getRowColumns } from "../../../services/formService";
import InfoViewer from "./Info_Viewer";
import QAViewer from "./QAViewer";
import ButtonViewer from './ButtonViewer';
import VideoViewer from "./VideoViewer";
import MDHDataViewer from "./MDHDataViewer";

class RowViewer extends Component {
  state = {
    Widget_ID: this.props.Widget_ID,
    SurveyMode: this.props.SurveyMode ? this.props.SurveyMode : false,
    Columns: [],
    Options: [],
    loading: true,
    Question_Number: this.props.Question_Number ? this.props.Question_Number : 0,
    Widget_Color: this.props.Widget_Color ? this.props.Widget_Color : '#0061f2',
    dataElements: this.props.dataElements ? this.props.dataElements : undefined,
		infoConfig: this.props.infoConfig ? this.props.infoConfig : undefined,
		sharedDataElement: this.props.sharedDataElement ? this.props.sharedDataElement : undefined,
    columnsDisabled: this.props.columnsDisabled ? this.props.columnsDisabled : [],
    columnsHidden: this.props.columnsHidden ? this.props.columnsHidden : []
  };

  async componentDidMount() {
    let { data: Columns } = await getRowColumns(this.state.Widget_ID);
    this.props.updateRowColumns(this.props.Widget_ID, Columns)
    let infoConfig = this.state.infoConfig, DEs = this.state.dataElements;
    if (this.state.sharedDataElement > 0) {
      Columns.map((col) => {
      //console.log(col.Column_Widget_ID, infoConfig.some(i => { if (i.Widget_ID === col.Column_Widget_ID) { return true; } }))
        if (infoConfig.some(i => { if (i.Widget_ID === col.Column_Widget_ID) { return true; } })) {
          let Widget_ID = col.Column_Widget_ID,
            resultSource = infoConfig.filter((infoEl) => infoEl.Widget_ID === Widget_ID)[0],
            destDE = DEs.filter((deEl) => deEl.ResultSource_Content === resultSource['ResultSource_Content']);
          col['sharedDataElement'] = destDE || [];
          col['resultSource'] = resultSource;
          return col;
        }
      });
    }

    let subquestion_number = 1
    let subquestion_count = 0
    let hidden_widget_count = 0
    Columns.forEach((col, idx) => {
      if (col.Column_Widget_Type_ID === WidgetTypes.QA && this.props.widgetsQA.length > 0) {
        const qa_widget = this.props.widgetsQA.filter(w => w.Widget_ID === col.Column_Widget_ID)[0]
        const parent_id = qa_widget.Parent_Question_Widget_ID
        const parent_widget_id = parent_id ? parent_id : 0
        const is_qa_widget_hidden = qa_widget.Hide ? qa_widget.Hide : false
        if (!is_qa_widget_hidden) {
          if (parent_widget_id !== 0) {
            col.Question_Number = (this.props.FormWidgets.filter(w => w.Widget_ID === parent_widget_id)[0].Question_Number + 1).toString() + String.fromCharCode(subquestion_number + 96)
            subquestion_number += 1
            subquestion_count += 1
          } else {
            subquestion_number = 1
            col.Question_Number = this.state.Question_Number + idx - hidden_widget_count - subquestion_count
          }
        } else {
          hidden_widget_count += 1
        }
      }
    })
    Columns.length!==0 && this.setState({ Columns });

    this.setState({ loading: false });
  }
  
  render() {
    return (
      <div className="row mb-2 mt-2">
        {
          this.state.Columns.map((col, idx) => (
            (col.Column_Widget_Type_ID !== WidgetTypes.QA ||
            (col.Column_Widget_Type_ID === WidgetTypes.QA && 
              !(this.props.widgetsQA.filter((w) => w.Widget_ID === parseInt(col.Column_Widget_ID)))[0].Hide)) &&
            <React.Fragment key={idx}>
            {col.Column_Widget_Type_ID !== WidgetTypes.Button && col.Column_Widget_Type_ID !== WidgetTypes.Video && 
              col.Column_Widget_Type_ID !== WidgetTypes.MDHData &&
              <div className="col" key={"V" + col.Column_Widget_ID}>
                {(col.Column_Widget_Type_ID === WidgetTypes.Info) && ( //add col widget type id in the db for these fields
                  <InfoViewer
                    key={"V" + col.Column_Widget_ID}
                    Widget_ID={col.Column_Widget_ID}
                    Widget_Type_ID={WidgetTypes.Info}
                    Project_ID={this.props.Project_ID}
                    Widget_Color={col.Widget_Color}
                    Col_ID={col.Column_ID}
                    dataElements={this.state.dataElements}
                    infoConfig={this.state.infoConfig}
                    sharedDataElement={col.sharedDataElement}
                    resultSource={col.resultSource}
                  />
                )}
                {(col.Column_Widget_Type_ID === WidgetTypes.QA) && (
                  <QAViewer
                    key={"V" + col.Column_Widget_ID}
                    Widget_ID={col.Column_Widget_ID}
                    Question_Number={col.Question_Number ? col.Question_Number : this.state.Question_Number + idx}
                    Form_ID={this.props.Form_ID}
                    OnUpdate={this.props.OnUpdate}
                    SurveyMode={this.props.SurveyMode}
                    PrimaryKey={this.props.PrimaryKey}
                    Project_ID={this.props.Project_ID}
                    selectedInst={this.props.selectedInst}
                    Widget_Type_ID={WidgetTypes.QA}
                    isRow={true}
                    Form_BehaviorOnLoad={this.props.Form_BehaviorOnLoad}
                    Form_BehaviorOnSave={this.props.Form_BehaviorOnSave}
                    Form_SecondaryIDName={this.props.Form_SecondaryIDName}
                    Form_SecondaryIDValue={this.props.Form_SecondaryIDValue}
                    widgetsQA={this.props.widgetsQA}
                    preloadFormData={this.props.preloadFormData}
                    Question_ID={(this.props.widgetsQA.filter((w) => w.Widget_ID == parseInt(col.Column_Widget_ID)))[0].Question_ID || null}
                    disabled={this.props.disabled ? this.props.disabled : this.state.columnsDisabled.includes(col.Column_Widget_ID) ? true : false}
                    Responses={this.props.Responses}
                    refreshWidget={this.props.refreshWidget}
                    handleRefreshWidget={this.props.handleRefreshWidget}
                    Hide={this.props.columnsHidden ? this.props.columnsHidden.includes(col.Column_Widget_ID) : false}
                  />
                )}
              </div>
            }
            {col.Column_Widget_Type_ID === WidgetTypes.Button &&
              <div className="ml-3"> 
                <ButtonViewer
                  key={col.Column_Widget_ID} 
                  Project_ID={this.props.Project_ID}
                  Form_ID={this.props.Form_ID} 
                  Widget_ID={col.Column_Widget_ID}
                  PrimaryKey={this.props.PrimaryKey}
                  Widget_Color={col.Widget_Color}
                  Custom_Save={this.props.Custom_Save}
                  selectedInst={this.props.selectedInst}
                  Form_SecondaryIDName={this.props.Form_SecondaryIDName}
					        Form_SecondaryIDValue={this.props.Form_SecondaryIDValue}
                  reloadForm={this.props.reloadForm}
                  closePopUpForm={this.props.closePopUpForm ? this.props.closePopUpForm : undefined}
                  disabled={this.props.disabled ? this.props.disabled : this.state.columnsDisabled.includes(col.Column_Widget_ID) ? true : false}
                />
              </div>
            }
            {col.Column_Widget_Type_ID === WidgetTypes.Video &&
              <VideoViewer
                key={col.Column_Widget_ID} 
                Project_ID={this.props.Project_ID}
                Form_ID={this.props.Form_ID} 
                Widget_ID={col.Column_Widget_ID}
                PrimaryKey={this.props.PrimaryKey}
              />
            }
            {col.Column_Widget_Type_ID === WidgetTypes.MDHData &&
              <MDHDataViewer
                key={col.Column_Widget_ID} 
                Project_ID={this.props.Project_ID}
                Form_ID={this.props.Form_ID} 
                Widget_ID={col.Column_Widget_ID}
                PrimaryKey={this.props.PrimaryKey}
              />
            }
            </React.Fragment>
          ))
          }
      </div>
    );
  }
}

export default RowViewer;
